const faq = require("./images/faq-handyman.png");

const FAQHandy = () => {
  const faqsList = [
    {
      q: "How does the payment process work for handymen?",
      a: "You can opt for a convenient monthly plan to access our platform's features.",
    },
    {
      q: "How do I communicate with clients and bid on jobs?",
      a: "Our platform allows you to interact with clients directly. You can browse job listings, communicate with potential clients through our messaging system, and submit your proposals or bids for specific projects.",
    },
    {
      q: "Do I need any specific qualifications or licenses to use your platform?",
      a: "While having the necessary licenses and qualifications may be required in some areas for certain services (e.g., electrical or plumbing work), our platform does not impose specific qualifications. It's your responsibility to comply with local regulations.",
    },
    {
      q: "How do I handle payments and invoices for my services?",
      a: "Payment arrangements are made directly between you and the client. You can discuss payment methods and issue invoices as needed.",
    },
    {
      q: "Can I use your platform on a mobile device?",
      a: "Yes, our platform is mobile-friendly, so you can easily access and use it from your smartphone or tablet.",
    },
  ];

  return (
    <section className="py-14" id="faq_handyman">
      <div className="max-w-screen-xl mx-auto px-4 gap-12 md:flex md:px-8">
        <div className="flex-1">
          <div className="max-w-lg">
            <p className="mt-3 text-gray-800 mb-2 text-3xl font-extrabold sm:text-4xl">
              Do you still have questions?
            </p>
            <img fetchpriority="low" src={faq} className="h-80" alt="FAQ" />
          </div>
        </div>
        <div className="flex-1 mt-12 md:mt-0">
          <ul className="space-y-4 divide-y">
            {faqsList.map((item, idx) => (
              <li className="py-5" key={idx}>
                <summary className="flex items-center justify-between font-semibold text-gray-700">
                  {item.q}
                </summary>
                <p
                  dangerouslySetInnerHTML={{ __html: item.a }}
                  className="mt-3 text-gray-600 leading-relaxed"
                ></p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FAQHandy;
